module.exports = __webpack_public_path__ + "img/shopify.66e1c555.png";